import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import changePasswordHelper from "../../helpers/auth/changePassword";
import forgotPasswordHelper from "../../helpers/auth/forgotPassword";
import getUserLoginInfo from "../../helpers/auth/getUserLoginInfo";
import {
  default as callLogout,
  default as logoutHelper,
} from "../../helpers/auth/logout";
import signInGuestHelper from "../../helpers/auth/signInGuestHelper";
import registrationHelper from "../../helpers/auth/signin";
import {
  getCookie,
  removeFromCookie,
  setCookie,
} from "../../helpers/other/cookies";
import { createObjForCookie } from "../../helpers/utils";
import { Tokens } from "../../types/webchatConversation";
import { clearChatMessages, getConversation } from "../chat/actions";
import {
  disconnectSocket,
  startConversation,
  startSocket,
} from "../socket/actions";
import { SOCKET_INITALIZED } from "../socket/constants";
import {
  changePassword,
  changePasswordFailed,
  changePasswordSuccess,
  forgotPassword,
  forgotPasswordFailed,
  forgotPasswordSuccess,
  loginUser,
  loginUserFailed,
  loginUserSuccess,
  logoutUserSuccess,
  signInGuest,
  signInGuestFailed,
  signInGuestSuccess,
  signin,
  signinFailed,
  signinSuccess,
} from "./actions";
import {
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  LOGIN_USER,
  LOGOUT_USER,
  SIGNIN,
  SIGN_IN_GUEST,
} from "./constants";

const setSession = (jwtToken: string | null, tokenType: string) => {
  if (jwtToken) {
    setCookie(tokenType, jwtToken, createObjForCookie());
  } else {
    removeFromCookie(tokenType, createObjForCookie());
  }
};

function* login({
  payload: { email, password },
}: ReturnType<typeof loginUser>) {
  try {
    const jwtAuthToken = yield call(getUserLoginInfo, email, password);
    if (getCookie(Tokens.AUTH_TOKEN)) {
      yield call(logoutHelper);
      yield put(logoutUserSuccess());
      yield put(clearChatMessages());
      window.location.href = "/";
    }
    yield setSession(jwtAuthToken, Tokens.AUTH_TOKEN);
    yield put(loginUserSuccess(jwtAuthToken));
    if (!getCookie(Tokens.GUEST_TOKEN)) {
      yield put(startSocket());
    }
    yield removeFromCookie(Tokens.GUEST_TOKEN, createObjForCookie());
    yield put(getConversation());
  } catch (error) {
    yield put(loginUserFailed());
    setSession(null, Tokens.AUTH_TOKEN);
  }
}

function* logout() {
  yield call(callLogout);
  setSession(null, Tokens.AUTH_TOKEN);

  localStorage.removeItem(Tokens.GUEST_TOKEN); // <--- dodaj ovo

  // Diskonektuj socket
  yield put(disconnectSocket());

  // Resetuj poruke ili konverzacije ako koristiš poseban reducer
  yield put({ type: "CLEAR_CHAT_MESSAGES" });
  yield put(logoutUserSuccess());
}

function* registration({
  payload: { email, password },
}: ReturnType<typeof signin>) {
  try {
    const jwtAuthToken = yield call(registrationHelper, email, password);
    if (getCookie(Tokens.AUTH_TOKEN)) {
      yield call(logoutHelper);
      yield put(clearChatMessages());
    }
    yield setSession(jwtAuthToken, Tokens.AUTH_TOKEN);
    yield put(signinSuccess(jwtAuthToken));
    if (!getCookie(Tokens.GUEST_TOKEN)) {
      yield put(startSocket());
    }
    yield removeFromCookie(Tokens.GUEST_TOKEN, createObjForCookie());
    yield put(getConversation());
  } catch (error) {
    let errorMsg = "Registration failed! Please try again.";
    if (error instanceof Error) {
      errorMsg = error.message;
    }
    yield put(signinFailed(errorMsg));
    setSession(null, Tokens.AUTH_TOKEN);
  }
}

function* forgotPass({
  payload: { email },
}: ReturnType<typeof forgotPassword>) {
  try {
    yield call(forgotPasswordHelper, email);
    yield put(forgotPasswordSuccess());
  } catch (error) {
    yield put(forgotPasswordFailed());
  }
}

function* changePass({
  payload: { password, tokenUrl },
}: ReturnType<typeof changePassword>) {
  try {
    yield call(changePasswordHelper, password, tokenUrl);
    yield put(changePasswordSuccess());
  } catch (error) {
    yield put(changePasswordFailed());
  }
}

function* signInGuestFunc({
  payload: { nickname },
}: ReturnType<typeof signInGuest>) {
  try {
    const jwtGuestToken = yield call(signInGuestHelper, nickname);
    if (getCookie(Tokens.AUTH_TOKEN)) {
      yield call(logoutHelper);
      yield removeFromCookie(Tokens.AUTH_TOKEN, createObjForCookie());
      yield put(clearChatMessages());
    }

    yield setSession(jwtGuestToken, Tokens.GUEST_TOKEN);
    yield put(signInGuestSuccess(jwtGuestToken));
    yield put(startSocket());
  } catch (error) {
    yield put(signInGuestFailed());
  }
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

export function* watchRegistration() {
  yield takeEvery(SIGNIN, registration);
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPass);
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePass);
}

export function* watchSignInGuest() {
  yield takeEvery(SIGN_IN_GUEST, signInGuestFunc);
}

function* socketInitialized() {
  yield put(startConversation());
}

function* watchSocketInitialized() {
  yield takeEvery(SOCKET_INITALIZED, socketInitialized);
}

function* authSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchSocketInitialized),
    fork(watchForgotPassword),
    fork(watchChangePassword),
    fork(watchRegistration),
    fork(watchSignInGuest),
  ]);
}

export default authSaga;
